import React from "react";
import SingleArticle from "../../components/singleArticle/SingleArticle";

function Blog() {
  return (
    <div className="blog">
      <SingleArticle />
    </div>
  );
}

export default Blog;
